import { render, staticRenderFns } from "./mainLayout.vue?vue&type=template&id=90374d12&scoped=true&"
import script from "./mainLayout.vue?vue&type=script&lang=ts&"
export * from "./mainLayout.vue?vue&type=script&lang=ts&"
import style0 from "./mainLayout.vue?vue&type=style&index=0&id=90374d12&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90374d12",
  null
  
)

export default component.exports